import React from "react"
import { Container, Row, Col, Button, Form, Card } from "react-bootstrap"
import { Formik, Field, ErrorMessage } from "formik"
import * as Yup from "yup"
import { cleanEntity } from "../../Common/js/clean_entity"
import withHooks from "../../Common/jsx/WithHooks"
import { getFamily, patchFamily, postFamily } from "../../api/api_family"

class FamilyForm extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    // CONFIG ==================================================================================================
    let emptyEntity = {
      name: "",
    }
    // /CONFIG =================================================================================================

    let entity
    let isReadyToRender
    if (this.props.entityId === undefined) {
      this.formType = "create"
      this.cardHeaderText = this.props.t("action.adding") + " " + this.props.t("entity." + this.props.entityType)
      entity = emptyEntity
      isReadyToRender = true
    } else {
      this.formType = "edit"
      this.cardHeaderText = this.props.t("action.editing") + " " + this.props.t("entity." + this.props.entityType) + " #" + this.props.entityId
      isReadyToRender = false
    }
    this.dMgr.debug("formType:", this.formType)

    this.state = {
      isReadyToRender: isReadyToRender,
      disable_button_validate: false,
      entity: entity,
      // CONFIG ==================================================================================================
      //relations from getRelatedEntities
      // /CONFIG =================================================================================================
    }
    this.dMgr.debug("init_state:", this.state)

    this.getEntity = this.getEntity.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.lockAndSubmit = this.lockAndSubmit.bind(this)
    this.getRelatedEntities = this.getRelatedEntities.bind(this)
    this.getFormValidationSchema = this.getFormValidationSchema.bind(this)
  }

  componentDidMount() {
    this.getEntity()
    this.getRelatedEntities()
  }

  async getEntity() {
    if (this.props.entityId !== undefined) {
      // CONFIG ==================================================================================================
      let entity = await getFamily(this.props.entityId)
      // /CONFIG =================================================================================================
      this.dMgr.debug("getEntity:", entity)
      this.setState({ entity, isReadyToRender: true })
    }
  }

  getRelatedEntities() {
    // CONFIG ==================================================================================================
    //nothing yet
    // /CONFIG =================================================================================================
  }

  getFormValidationSchema() {
    // CONFIG ==================================================================================================
    return Yup.object().shape({
      name: Yup.string().required(this.props.t("message.required")),
    })
    // /CONFIG =================================================================================================
  }

  async lockAndSubmit(values, { setSubmitting }) {
    this.dMgr.debug("lockAndSubmit:", values)
    this.setState({ disable_button_validate: true }, () => this.handleSubmit(values, { setSubmitting }))
  }

  async handleSubmit(values, { setSubmitting }) {
    this.dMgr.debug("handleSubmit:", values)

    try {
      // CONFIG ==================================================================================================

      let entity = cleanEntity(values)
      let newEntity = {}
      if (entity.id === undefined) {
        this.dMgr.debug("post entity:", entity)
        newEntity = await postFamily(entity)
      } else {
        this.dMgr.debug("patch entity:", entity.id, entity)
        newEntity = await patchFamily(entity.id, entity)
      }

      this.dMgr.debug("success entity:", newEntity.id, newEntity)
      this.props.notif.success()
      this.props.router.nav({
        prefix: "admin",
        entitiesType: this.props.entitiesType,
      })
      // /CONFIG =================================================================================================
    } catch (err) {
      this.dMgr.error("COUGHT EXCEPTION:", err)
      this.props.notif.failed(err)
    } finally {
      this.setState({ disable_button_validate: false })
      setSubmitting(false)
    }
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    let toRender = (
      <Container>
        <Formik enableReinitialize initialValues={this.state.entity} validationSchema={this.getFormValidationSchema} onSubmit={this.lockAndSubmit}>
          {({ handleSubmit, handleChange, values, touched, errors }) => (
            <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
              <Row>
                <Col md={3}></Col>
                <Col md={6}>
                  <Card className="bg-dark text-white box-shadow-lvl3">
                    <Card.Header>{this.cardHeaderText}</Card.Header>
                    <Card.Body>
                      {/* CONFIG ==================================================================================== */}
                      <Container fluid>
                        <Row>
                          <Col md={3}></Col>
                          <Col md={6}>
                            <Form.Group controlId="formName">
                              <Form.Label>{this.props.t("form.name") + this.props.t("app.dbp")}</Form.Label>
                              <Field as={Form.Control} name="name" isInvalid={touched.name && errors.name} onChange={handleChange} value={values.name} />
                              <Form.Control.Feedback type="invalid">
                                <ErrorMessage name="name" />
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                        <br />
                        <br />
                        <Row>
                          <Col md={4}></Col>
                          <Col md={2} className="text-center">
                            <Button
                              id="btn-cancel"
                              onClick={() =>
                                this.props.router.nav({
                                  url: this.props.router.location.state.referrerUrl,
                                })
                              }
                              variant="secondary"
                              size="sm"
                              className="margin-right-5"
                            >
                              {this.props.t("action.cancel")}
                            </Button>
                          </Col>
                          <Col md={2} className="text-center">
                            <Button id="btn-submit" variant="primary" size="sm" type="submit" disabled={this.state.disable_button_validate} className="margin-right-5">
                              {this.props.t("action.validate")}
                            </Button>
                          </Col>
                        </Row>
                      </Container>
                      {/* /CONFIG ================================================================================ */}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Container>
    )

    this.dMgr.renderDone()
    return toRender
  }
}

export default withHooks(FamilyForm)
